import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../material/material.module';
import {NgModule} from '@angular/core';
import {SuperMarketUploadSecondStepComponent} from './super-market-upload-second-step.component';

@NgModule({
  declarations: [SuperMarketUploadSecondStepComponent],
  exports: [SuperMarketUploadSecondStepComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})

export class SuperMarketUploadSecondStepModule {
}
